import { ButtonProps } from '@mui/material';
export const productCardActionIconButtonProps: ButtonProps = {
	variant: 'outlined',
	sx: { my: 1, padding: '3px' },
};
